import { create } from "zustand";
import { persist } from "zustand/middleware";

import { LOCALES, type Locale, type TranslationKey, translate } from "@/constants/i18n";

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

/** The browser's preference, if we speak it; English otherwise. */
function preferredLocale(): Locale {
  if (typeof navigator === "undefined") return "en";
  const supported = LOCALES.map((entry) => entry.code);
  for (const candidate of navigator.languages ?? [navigator.language]) {
    const base = candidate.toLowerCase().split("-")[0] as Locale;
    if (supported.includes(base)) return base;
  }
  return "en";
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: preferredLocale(),
      setLocale: (locale) => set({ locale }),
    }),
    { name: "mrm.locale" },
  ),
);

/** `const t = useTranslation()` then `t("login.welcome")`. */
export function useTranslation(): (key: TranslationKey) => string {
  const locale = useLocaleStore((state) => state.locale);
  return (key) => translate(locale, key);
}
